import { IFilterControl } from "../../models/report-interface";
import { Component, EventEmitter, Input, Output } from "@angular/core";
declare var $: any;

@Component({
    selector: "filterControls",
     template: `
       <div class="ui fluid popup filterOptions bottom right transition hidden fullWidth">
         <div class="ui form">
           <div class="fields">
             <div [ngClass]="control.sizeClass" class="wide field" *ngFor="let control of filterControls"
                  [ngSwitch]="control.type">
               <ng-template [ngSwitchCase]="'DropDownThreeOptionFilter'">
                 <div class="ui">
                   <div class="ui simple dropdown selection filter">
                     {{control.selectedData.description}}
                     <i class="dropdown icon"></i>
                     <div class="menu" [attr.id]="control.name">
                       <div [attr.id]="item.value" class="item"
                            [ngClass]="{active: control.selectedData.value === item.value}"
                            *ngFor="let item of control.data"
                            (click)="control.activate(item)">{{item.description}}
                       </div>
                     </div>
                   </div>
                 </div>
                 <label>{{control.title}}</label>
               </ng-template>
               <ng-template [ngSwitchCase]="'DropDownReferenceDataFilter'">
                 <dropDownReferenceDataFilter [filterControl]="control" (refFilterApply)="refFilterApply($event)"></dropDownReferenceDataFilter>
               </ng-template>
               <ng-template [ngSwitchCase]="'NumberFilter'">
                 <inputFilter [filterControl]="control" icon (refFilterApply)="refFilterApply($event)"></inputFilter>
               </ng-template>
             </div>
           </div>
           <div class="ui divider compact light"></div>
           <button id="filterResetBtn" [ngClass]="{disabled: !canClearAll}" class="floated left ui button compact" (click)="filterReset()">Clear All</button>
           <button id="filterApplyBtn" class="floated right ui primary button compact filterApply"
                   (click)="filterApply()">Apply
           </button>
         </div>
       </div>
     `,
})

export class FilterControlComponent {
    @Input() public filterControls: IFilterControl[];
    @Input() public buttonControl: string;
    @Output() public filtersApply: EventEmitter<any> = new EventEmitter();

    public canClearAll = false;

    public filterApply() {
        this.filtersApply.emit(this.filterControls);
        if (typeof $ !== "undefined") { $(".filterBtn").click(); }
    }

    public filterReset() {
     this.filterControls.forEach((control) => {
        if (control.type === "DropDownReferenceDataFilter" ) {
          const showItem = control.data.filter((item) => item.id === 0)[0];
          control.activate(showItem);
        } else {
          control.activate("");
        }});
        this.canClearAll = false;
    }

    public ngOnInit() {
        if (typeof $ !== "undefined") {
            $(`#${this.buttonControl}`).popup({
                on    : "click",
                popup: ".filterOptions",
                position : "bottom right",
            });
        }
        this.checkCanClearAll();
    }

    private refFilterApply(filterControl) {
      this.checkCanClearAll();
    }

    private checkCanClearAll() {
      const totalFilters = this.filterControls.length;
      // If id > 0 = not "Show All", can activate "Clear All" button
      const showAllFilters = this.filterControls.filter((control) => {
        if (control.type === "DropDownReferenceDataFilter" ) {
          return control.selectedData.id === 0;
        } else {
          return control.selectedData === "";
        }}).length;
      if (showAllFilters < totalFilters) {
        this.canClearAll = true;
      } else {
        this.canClearAll = false;
      }
    }
}



// WEBPACK FOOTER //
// ./client/app/shared/reportControls/filter-control-component.ts